import { focusWithoutScroll } from '../../common/focus-without-scroll/focus-without-scroll.js';
const initializedGalleries = new WeakSet();

function bindGallery(root) {
    if (initializedGalleries.has(root)) return;
    initializedGalleries.add(root);
    let opening = false;

    root.addEventListener('click', async (event) => {
        if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
        )
            return;
        const target =
            event.target instanceof Element
                ? event.target.closest('[data-content-lightbox-item]')
                : null;
        if (!target || target.closest('[data-content-lightbox]') !== root) return;
        const links = [...root.querySelectorAll('[data-content-lightbox-item]')];
        const slides = links.map((link) => ({
            src: link.href,
            srcset: link.dataset.lightboxSrcset || '',
            width: Number(link.dataset.lightboxWidth),
            height: Number(link.dataset.lightboxHeight),
            alt: link.querySelector('img')?.alt || '',
            msrc: link.querySelector('img')?.currentSrc || '',
        }));
        // Missing metadata retains the normal full-resolution link fallback.
        if (slides.some((slide) => !(slide.width > 0 && slide.height > 0))) return;
        event.preventDefault();
        if (opening) return;
        opening = true;
        try {
            const { openPhotoSwipeViewer } =
                await import('../../common/photoswipe-viewer/photoswipe-viewer.js');
            if (!root.isConnected || !target.isConnected) return;
            focusWithoutScroll(target);
            openPhotoSwipeViewer({
                slides,
                index: links.indexOf(target),
                labels: {
                    gallery: 'Bildergalerie in Großansicht',
                    previous: 'Vorheriges Bild',
                    next: 'Nächstes Bild',
                },
            });
        } catch {
            if (target.isConnected) window.location.assign(target.href);
        } finally {
            opening = false;
        }
    });
}

export function initContentGalleries(root = document) {
    if (root.matches?.('[data-content-lightbox]')) bindGallery(root);
    root.querySelectorAll?.('[data-content-lightbox]').forEach(bindGallery);
}
